import { ofType } from "redux-observable"
import { catchError, EMPTY, from, mergeMap } from "rxjs"
import EventBus from "../../../../common/EventBus"
import { setPricingTable } from "../../../pricing/actions"
import { ProjectAction } from "../../../project"
import { InventoryStockDocumentDefinitionAction } from "../../stockDocumentDefinition"
import { Action } from "../actions/actions"
import { ACTION_TYPES } from "../actions/types"
import { StockDocument } from "../models"
import { Selector } from "../selectors/selectors"
import { Service } from "../services/service"

export const fetchEpic = (action$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.FETCH),
        mergeMap(({payload}) => {
            return from(Service.get(payload)).pipe(
                mergeMap(res => {
                    const doc = res as StockDocument
                    return [
                        Action.fetchSuccess(doc),
                        ProjectAction.fetchSuccess(doc.attributes.project),
                        InventoryStockDocumentDefinitionAction.fetchSuccess(doc.attributes.definition),
                        setPricingTable(doc.attributes.table)
                    ]
                }),
                catchError((error) => {
                    console.error("Error fetching stock document :", error)
                    return EMPTY
                })
            )
        })
    )
}

export const reloadEpic = (action$, state$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.RELOAD),
        mergeMap(() => {
            const id = Selector.getId(state$.value)
            return from(Service.get(id)).pipe(
                mergeMap(res => {
                    const doc = res as StockDocument
                    return [
                        Action.fetchSuccess(doc),
                        ProjectAction.fetchSuccess(doc.attributes.project),
                        InventoryStockDocumentDefinitionAction.fetchSuccess(doc.attributes.definition),
                        setPricingTable(doc.attributes.table)
                    ]
                }),
                catchError(() => EMPTY)
            )
        })
    )
}

export const createEpic = (action$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.CREATE),
        mergeMap(({payload}) => {
            return Service.post(payload).then(res => {
                if (res && !res.error) {
                    window.location.href = `/stock-documents/${res.id}/edit`
                }
            })
        }),
        catchError(() => EMPTY)
    )
}
export const createFromReferenceEpic = (action$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.CREATE_FROM_REFERENCE),
        mergeMap(({payload}) => {
            return Service.createFromReference(payload).then(res => {
                if (res && !res.error) {
                    window.location.href = `/stock-documents/${res.id}/edit`
                }
            })
        }),
        catchError(() => EMPTY)
    )
}

export const deleteEpic = (action$, state$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.DELETE),
        mergeMap(() => {
            const id = Selector.getId(state$.value)
            return Service.delete(id).then(res => {
                if (res && !res.error) {
                    return Action.fetchSuccess(res)
                }
                return EMPTY
            })
        }),
        catchError(() => EMPTY)
    )
}

export const unarchiveEpic = (action$, state$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.UNARCHIVE),
        mergeMap(() => {
            const id = Selector.getId(state$.value)
            return Service.unarchive(id).then(res => {
                if (res && !res.error) {
                    return Action.fetchSuccess(res)
                }
                return EMPTY
            })
        }),
        catchError(() => EMPTY)
    )
}

export const markAsDoneEpic = (action$, state$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.MARK_AS_DONE),
        mergeMap(() => {
            const id = Selector.getId(state$.value)
            return Service.markAsDone(id).then(res => {
                if (res && !res.error) {

                    EventBus.dispatch(EventBus.TopicUrlPathChange, {
                        path: `/stock-documents/${id}/edit`
                    })

                    return Action.fetchSuccess(res)
                }
                return EMPTY
            })
        }),
        catchError(() => EMPTY)
    )
}


export const inventoryAdjustmentEpic = (action$, state$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.ADJUST_INVENTORY),
        mergeMap(({payload}) => {
            const id = Selector.getId(state$.value)
            return from(Service.inventoryAdjustmentItemMovement(id, payload)).pipe(
                mergeMap(res => {
                    const doc = res as StockDocument
                    if (res) {
                        return [
                            Action.fetchSuccess(res),
                            setPricingTable(doc.attributes.table)
                        ]

                    }
                    return EMPTY

                }
                ),
                catchError(() => EMPTY)
            )
        }))
}



export const quickCreateStockDocumentEpic = (action$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.QUICK_CREATE_STOCK_DOCUMENT),
        mergeMap(({payload}) => {
            return Service.quickCreateStockDocument(payload).then(res => {
                if (res && !res.error) {
                    window.location.href = `/stock-documents/${res.id}/edit`
                }
            })
        }),
        catchError(() => EMPTY)
    )
}


// WEBPACK FOOTER //
// ./src/state/inventory/stockdocument/epics/epics.ts